import React, { useState } from 'react';
import './index.scss';
import RemoteCallModal from '@/components/RemoteCallModal';

const RemoteCall = (props: {
  vehicleName: string;
  cockpitNumber: string;
  closeDropdown: () => void;
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  return (
    <>
      <button
        className="vehicle-command-btn"
        onClick={(e) => {
          e.stopPropagation();
          setVisible(true);
          props.closeDropdown();
        }}
      >
        远程喊话
      </button>
      <RemoteCallModal
        visible={visible}
        vehicleName={props.vehicleName}
        setVisible={setVisible}
      />
    </>
  );
};

export default React.memo(RemoteCall);
